<template>
  <div>
    <ExpandableCard
      src="assets/help/contactless.svg"
      :title="$t('charge_help.card1_title')"
      v-show="!matchEntities(['POLAND'])"
    >
      <p class="card-text">
        {{ $t('charge_help.card1_text1') }}
      </p>
      <div class="nfc-logo">
        <img src="~@/assets/help/nfc-ic.svg" />
      </div>
      <div>
        <p class="card-text">
          {{ $t('charge_help.card1_text2') }}
        </p>
        <div class="payment-logo-parent">
          <div
            style="height: 100%; margin: 10px"
            v-for="(data, idx) in contactLess"
            :key="idx"
          >
            <LogoImage :data="data" />
          </div>
        </div>
        <p class="card-text">
          {{ $t('charge_help.card1_text3') }}
        </p>
      </div>
    </ExpandableCard>
    <ExpandableCard
      src="assets/help/roaming.svg"
      :title="$t('charge_help.card2_title')"
    >
      <p class="card-text">
        {{ $t('charge_help.card2_text1') }}
      </p>
      <div class="nfc-logo">
        <img src="~@/assets/help/nfc-ic.svg" />
      </div>
      <p class="card-text">
        {{ $t('charge_help.we_accept') }}
      </p>
      <div class="partner-logo-parent">
        <LogoImage v-for="(data, idx) in logoData" :key="idx" :data="data" />
      </div>
      <p class="card-text">
        {{ $t('charge_help.card2_text2') }}
      </p>
    </ExpandableCard>
    <ExpandableCard
      src="assets/help/mobile.svg"
      :title="$t('charge_help.card3_title')"
    >
      <p
        class="card-text"
        v-for="(line, key) in $t('charge_help.card3_text1').split('\n')"
        :key="key"
      >
        {{ line }}
      </p>
      <p class="card-text">
        {{ $t('charge_help.card3_text2') }}
      </p>
    </ExpandableCard>
  </div>
</template>
<script>
import contactLess from '@/data/payment.json';
import { entity } from '@/../region.json';
import logoData from '@/data/logos.json';
import matchEntities from '../../shared/entityHelpers';
import ExpandableCard from './ExpandableCard.vue';
import LogoImage from './Logo.vue';

const filtered = logoData
  .filter(logo => logo.entity.includes(entity))
  .sort((a, b) => a.rank[entity] - b.rank[entity]);
export default {
  name: 'ActivateCharger',
  data() {
    return {
      contactLess,
      logoData: filtered,
    };
  },
  components: {
    ExpandableCard,
    LogoImage,
  },
  methods: {
    matchEntities,
  },
};
</script>

<style scoped>
.card-text {
  margin-top: 20px;
  color: #2b4047;
}
.nfc-logo {
  margin: 2em auto;
  max-width: max-content;
}
.partner-logo-parent,
.payment-logo-parent {
  display: grid;
  grid-auto-rows: 60px;
  place-items: center;
}
.partner-logo-parent {
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
}
.payment-logo-parent {
  grid-template-columns: repeat(auto-fill, minmax(53px, 1fr));
}
</style>
